export { default as Label, type LabelProps } from './Label';
export type { LabelInfoProps } from './LabelInfo';
